import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { afterNextRender, Component, computed, inject, signal } from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoModule } from "@ngneat/transloco";
import { tuiPure } from "@taiga-ui/cdk";
import { TuiDurationOptions, tuiSlideInRight } from "@taiga-ui/core";
import { TrackingService } from "../../domain/analytics/analytics.service";

const BANNERS_LOCAL_STORAGE_KEY = "banners";

@Component({
  selector: "dev-portal-banner-modal",
  templateUrl: "./banner-modal.component.html",
  imports: [OverlayModule, CommonModule, TranslocoModule],

  animations: [tuiSlideInRight]
})
export class BannerModalComponent {
  private router = inject(Router);
  private trackingService = inject(TrackingService);

  // banners which are not closed by the user
  activeBannerList = signal<Record<string, boolean>>({
    "fusion-solana": true
  });

  isOpen = computed(() => {
    return Object.values(this.activeBannerList()).some((value) => value);
  });

  constructor() {
    afterNextRender(() => {
      const bannersFromLocalStorage = window.localStorage.getItem(BANNERS_LOCAL_STORAGE_KEY);
      if (bannersFromLocalStorage) {
        this.activeBannerList.update((activeBannerList) => {
          return { ...activeBannerList, ...JSON.parse(bannersFromLocalStorage) };
        });
      } else {
        window.localStorage.setItem(BANNERS_LOCAL_STORAGE_KEY, JSON.stringify(this.activeBannerList()));
      }
    });
  }

  @tuiPure
  getAnimation(): TuiDurationOptions {
    return { value: "", params: { duration: 300 } };
  }

  onCloseBanner(bannerName: string) {
    this.trackingService.trackEvent("banners", {
      event_action: "click",
      event_label: bannerName,
      event_type: "button",
      event_value: "close"
    });
    this.activeBannerList.update((activeBannerList) => {
      activeBannerList[bannerName] = false;
      window.localStorage.setItem(BANNERS_LOCAL_STORAGE_KEY, JSON.stringify(this.activeBannerList()));
      return activeBannerList;
    });
  }

  onLearnMore(bannerName: string) {
    this.trackingService.trackEvent("banners", {
      event_action: "click",
      event_label: bannerName,
      event_type: "button",
      event_value: "primary"
    });
    this.onCloseBanner(bannerName);
    switch (bannerName) {
      case "fusion-plus":
        this.router.navigate([`/documentation/apis/swap/fusion-plus/introduction`]);
        break;
      case "fusion-solana":
        this.router.navigate([
          "/documentation/apis/swap/intent-swap/fusion-sdk/solana/for-integrators/getting-started"
        ]);
        break;
      default:
        break;
    }
  }
}
